// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2FQWt","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1N_TI"};